import React from 'react'

import { Button } from '../../components/Button'
import { Calendar, CalendarProps, DateRange } from '../../components/Calendar'
import { Modal, ModalProps } from '../../components/Modal'

interface BaseCalendarInputModalProps extends ModalProps {
  /**
   * Calendar mode
   */
  mode: 'single' | 'multiple' | 'range'

  /**
   * Modal title
   */
  title?: string

  /**
   * From date
   */
  fromDate?: CalendarProps['fromDate']

  /**
   * To date
   */
  toDate?: CalendarProps['toDate']

  /**
   * Submit button label
   */
  submitLabel?: string
}

export interface SingleCalendarInputModalProps
  extends BaseCalendarInputModalProps {
  /**
   * Calendar mode
   */
  mode: 'single'

  /**
   * Initial date
   */
  initialDate?: Date

  /**
   * onSubmit callback
   */
  onSubmit: (date: Date) => void
}

export interface MultipleCalendarInputModalProps
  extends BaseCalendarInputModalProps {
  /**
   * Calendar mode
   */
  mode: 'multiple'

  /**
   * Initial date
   */
  initialDate?: Date[]

  /**
   * onSubmit callback
   */
  onSubmit: (dates: Date[]) => void
}

export interface RangeCalendarInputModalProps
  extends BaseCalendarInputModalProps {
  /**
   * Calendar mode
   */
  mode: 'range'

  /**
   * Initial date
   */
  initialDate?: DateRange

  /**
   * onSubmit callback
   */
  onSubmit: (dateRange: DateRange) => void
}

export type CalendarInputModalProps =
  | SingleCalendarInputModalProps
  | MultipleCalendarInputModalProps
  | RangeCalendarInputModalProps

export const CalendarInputModal = ({
  title = '利用日時',
  submitLabel = '決定',
  mode,
  initialDate,
  fromDate,
  toDate,
  onSubmit,
  ...modalProps
}: CalendarInputModalProps) => {
  // One of `Date | Date[] | DateRange | undefined`
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [selected, handleSelect] = React.useState<any>(initialDate)

  return (
    <Modal title={title} {...modalProps}>
      <Modal.Body centered>
        <Calendar
          mode={mode}
          selected={selected}
          onSelect={handleSelect}
          fromDate={fromDate}
          toDate={toDate}
          my={10}
          mx={[0, 10]}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary-outlined"
          size="lg"
          onClick={() => {
            if (selected) onSubmit(selected)
            modalProps.onClose?.()
          }}
          disabled={!selected}
          fullWidth
        >
          {submitLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
